export default "__VITE_ASSET__DRUeWvaj__"